// src/Routes/routes.js
import { lazy } from 'react';


const Home = lazy(() => import('../views/FuturityJournal'));
const Login = lazy(() => import('../component/home/login'));
const Registration = lazy(() => import('../component/home/registration'));
const AboutTheJournal = lazy(() => import('../component/about/aboutTheJournal'));
// const Works = lazy(() => import('../components/Page/Works'));
const AuthorGuidelines = lazy(() => import('../component/guidelines/authorGuidelines'));
const SubmissionGuidelines = lazy(() => import('../component/guidelines/submissionGuidelines'));
const ReviewProcess = lazy(() => import('../component/guidelines/peerReviewProcess'));
const EditorialBoard = lazy(() => import('../component/about/editorialBoard'));
const Contact = lazy(() => import('../component/about/contact'));
const Announcements = lazy(() => import('../component/home/announcements'));
const PolicyOfJournal = lazy(() => import('../component/home/policyOfJournal'));
const ArticleFee = lazy(() => import('../component/home/articleFee'));
const Myresearch = lazy(() => import('../component/research/myResearch'));
const ResearchDetails = lazy(() => import('../component/research/researchDetails'));
// const NotFound = lazy(() => import('../components/Page/NotFound'));
// const ProtectedPage = lazy(() => import("../components/Page/ProtectedPage"));
// const MapComponent = lazy(() => import('../components/GoogleMap/googleMapComponent'));
const ArticleDetails = lazy(() => import('../component/home/articleDetails'));

const Research = lazy(() => import('../component/home/research'));
const Opening = lazy(() => import('../views/home'));
const NoDataAvailable = lazy(() => import('../views/noDataAvailable'));

const routes = [
  { path: '/', element: <Opening /> },
  { path: '/login', element: <Login /> },
  { path: '/register', element: <Registration /> },
  { path: '/about-journal', element: <AboutTheJournal /> },
  { path: '/editorial-board', element: <EditorialBoard /> },
  // { path: '/about', element: <About /> },
  { path: '/author-guidelines', element: <AuthorGuidelines /> },
  { path: '/submission-guidelines', element: <SubmissionGuidelines /> },
  { path: '/review-process', element: <ReviewProcess /> },
  { path: '/contact-us', element: <Contact /> },
  { path: '/announcements', element: <Announcements /> },
  { path: '/policy', element: <PolicyOfJournal /> },
  { path: '/article-fee', element: <ArticleFee /> },
  { path: '/research', element: <Research /> },
  { path: '/home', element: <Home /> },
  { path: '/my-research', element: <Myresearch /> },
  { path: '/research-details', element: <ResearchDetails /> },
  { path: '/article-details', element: <ArticleDetails /> },
  // { path: '/map', element: <MapComponent /> },
  // { path: '/protected', element: <ProtectedPage />, isProtected: true },
  // { path: '*', element: <NotFound /> }


   // Catch-all (404 or no data)
  { path: '*', element: <NoDataAvailable /> }
];

export default routes;